import { NewsCategory } from '@pt/models';

export function getCategoriesMock(count = 12): NewsCategory[] {
  const categories: NewsCategory[] = [];

  categories.push({
    id: null,
    name: 'All',
    iconName: 'gift',
    isDeletable: true,
    visible: true,
  });

  for (let i = 1; i <= count; i++) {
    categories.push({
      id: i,
      name: `Category ${i}`,
      iconName: 'gift',
      isDeletable: true,
      visible: true,
    });
  }

  categories.push({
    id: categories.length + 1,
    name: 'Coins',
    iconName: 'gift',
    isDeletable: true,
    visible: true,
  });

  return categories;
}
